import { toast } from "sonner";

// El servidor responde 503 mientras los pagos en línea (Stripe) no están configurados.
// En ese caso no se muestra un error: se invita a contactar. Con Stripe listo, el pago sigue normal.
export const pagosNoDisponibles = (e) => e?.response?.status === 503;

export function avisoPagosPronto(t, onContact) {
  toast(t.custom.toasts.soonTitle, {
    description: t.custom.toasts.soonDesc,
    duration: 15000,
    action: { label: t.custom.toasts.soonContact, onClick: onContact },
    cancel: {
      label: "contact@atlantisintlsourcing.com",
      onClick: () => {
        window.location.href = "mailto:contact@atlantisintlsourcing.com";
      },
    },
  });
}
